window.VUE_APP_BIOCHEMISTRY_SHARED_PATH = process.env.VUE_APP_BIOCHEMISTRY_SHARED_PATH

import('./chemicalBootstrap')
